/* DVR - COR QUE A PECA NAO TEM NAO PODE SER ESCOLHIDA. (Claude, 05/10/2026)

   O QUE ACONTECIA. A oversized existe em duas cores, preto e off white. O
   motor da pagina (vf-molde.js, montaCores) continua desenhando as nove cores
   da linha e marcando sete delas como .vfm-extra, que e a bolinha de previa.
   Desde 29/09 elas ficam escondidas pelo bloco COR SEM VARIANTE NAO APARECE do
   dvr-abre.js, e por isso ninguem reclamou: o cliente nao via.

   So que o PROPRIO dvr-abre.js, no bloco de cima, carrega a escolha feita na
   pagina anterior procurando a bolinha pelo data-k, e a funcao achaPor devolve
   a escondida como reserva quando nao acha nenhuma visivel. Resultado: quem
   estava numa camiseta verde e tocava em Oversized caia numa pagina com a peca
   verde desenhada, o botao de comprar desligado escrito cor ainda nao
   cadastrada e um recado tecnico sobre cores de previa. Verde nao existe em
   oversized: a pagina prometia o que nao da para vender.

   O QUE ESTE ARQUIVO FAZ. Barra o clique em qualquer bolinha de cor que nao
   esteja visivel, na fase de captura, antes de qualquer outro ouvinte. Clique
   de gente nunca passa por aqui, porque bolinha escondida nao recebe clique de
   gente: quem e barrado e o clique PROGRAMADO. Sem a selecao falsa a cor fica a
   que a propria pagina abriu, o botao de comprar continua ligado e o recado
   nunca nasce.

   Segunda rede, para o caso de uma cor de previa chegar acesa por outro
   caminho: a selecao e desfeita devolvendo o clique para a primeira cor de
   verdade.

   Por que aqui e nao la dentro: vf-molde.js tem 32 KB e dvr-abre.js 20 KB, e
   reescrever qualquer um dos dois por causa disto poe o customizador em risco.
   Este arquivo nao toca em motor nenhum. Apagar a linha que o chama em
   snippets/scripts.liquid devolve tudo ao que era.
*/
(function () {
'use strict';

/* escondida = sem retangulo. pega display:none proprio e de qualquer ancestral,
   e nao confunde com elemento que apenas saiu da area rolada da fila. */
function visivel(e) {
  return !!(e && e.getClientRects && e.getClientRects().length);
}

function primeiraReal() {
  var bs = document.querySelectorAll('.vf-cor');
  for (var i = 0; i < bs.length; i++) {
    if (visivel(bs[i]) && !bs[i].classList.contains('vfm-extra')) return bs[i];
  }
  return null;
}

/* captura no documento: roda antes do ouvinte do proprio botao e antes do
   ouvinte da fila, os dois registrados com captura no vf-molde.js */
document.addEventListener('click', function (ev) {
  var alvo = (ev.target && ev.target.closest) ? ev.target.closest('.vf-cor') : null;
  if (!alvo || visivel(alvo)) return;
  ev.stopImmediatePropagation();
  ev.preventDefault();
}, true);

/* a rede de baixo. so age quando ha uma cor de previa acesa, e devolver o
   clique para uma cor real deixa a condicao falsa: nao existe laco. */
var t = null;
function corrige() {
  var on = document.querySelector('.vf-cor.on');
  if (!on) return;
  if (visivel(on) && !on.classList.contains('vfm-extra')) return;
  var bom = primeiraReal();
  if (!bom || bom === on) return;
  bom.click();
}
function agenda() { clearTimeout(t); t = setTimeout(corrige, 90); }

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', agenda);
else agenda();
window.addEventListener('load', agenda);

if (window.MutationObserver) {
  new MutationObserver(agenda).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style']
  });
}
})();
